import { defaultCompanyState } from './module-company-state';

export default {
	resetState(state) {
		Object.assign(state, defaultCompanyState);
	},
	updateCompanyInfo(state, info) {
		state.companyInfo = info;
	},
	updateVersionAgreement(state, value) {
		state.companyInfo.VersionAgreement = value;
	}
};
